import React from 'react'

import { HeroNumericsHeader } from '@cash-design-system/react'
import { HorizontalAlignment } from '@cash-web/protos/squareup/cash/ui/arcade/elements/HorizontalAlignment.pb'
import { FormBlockerElementHeroNumericsHeaderElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import logger from '@cash-web/shared/util-logger'

export function HeroNumericsHeaderElement(props: FormBlockerElementHeroNumericsHeaderElement): React.ReactElement {
  const title = props.header?.title_text?.translated_value ?? ''
  const sectionTitle = props.header?.section_title_text?.translated_value
  const bodyText = props.header?.body_text?.text?.translated_value
  const bodyIcon = props.header?.body_text?.icon
  const additionalBodyText = props.header?.additional_body_text?.translated_value
  const horizontalAlignment = props.header?.horizontal_alignment

  if (!props.header?.title_text?.translated_value) {
    logger.error(new Error('HeroNumericsHeaderElement: title_text is required but not provided, using empty string'))
  }

  if (props.header?.body_text?.tint_color) {
    logger.warn(new Error('HeroNumericsHeaderElement: tint_color is not implemented for body_text'))
  }

  const getHorizontalAlignment = (alignment?: HorizontalAlignment): 'leading' | 'center' | 'trailing' => {
    switch (alignment) {
      case HorizontalAlignment.LEADING:
        return 'leading'
      case HorizontalAlignment.TRAILING:
        return 'trailing'
      case HorizontalAlignment.HORIZONTALLY_CENTERED:
      default:
        return 'center'
    }
  }

  return (
    <HeroNumericsHeader
      title={title}
      titleElement="h1"
      sectionTitle={sectionTitle}
      bodyParagraph1={
        bodyText
          ? {
              copy: bodyText,
              icon: bodyIcon,
            }
          : undefined
      }
      bodyParagraph2={additionalBodyText}
      horizontalAlignment={getHorizontalAlignment(horizontalAlignment)}
    />
  )
}
